export default __webpack_public_path__ + "c5161e7a73c9d403d348d206010b8685.svg";